import { useContext } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import { StateContext } from '../control/state';

export const useActiveThreadId = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const state = useContext(StateContext);
  const threadId = searchParams.get('threadId') ?? undefined;
  const setThreadId = (threadId: string | undefined) => {
    const newSearchParams = new URLSearchParams(searchParams);
    if (threadId) {
      newSearchParams.set('threadId', threadId);
    } else {
      newSearchParams.delete('threadId');
    }
    navigate({
      pathname: location.pathname,
      search: newSearchParams.toString(),
    });
    state.setRunState({ type: 'empty' });
    state.clearUpdates();
  };

  return { threadId, setThreadId };
};
